// API Configuration
// Update this file after deploying your Cloudflare Worker

// Default: uses localStorage (for development/demo)
// After deploying Cloudflare Worker, uncomment and update the API_URL
export const USE_API = true; // Set to true after deploying the worker
export const API_URL = 'https://geomark-blog-api.lashaavalishvili999.workers.dev';
export const API_PASSWORD = 'geomark2024';

// Instructions:
// 1. Deploy the Cloudflare Worker (see worker/README.md)
// 2. Copy the Worker URL from Wrangler output
// 3. Update API_URL above with your Worker URL
// 4. Set USE_API = true
// 5. Rebuild and redeploy your React app
